// 49 CFR 172.301(a)(1): the identification number is marked preceded by "UN",
// "NA" or "ID". One optional space matches how dotDescription reads a number
// off a manifest ("UN 1993").
// Capitals only: the number prints as stored, and "un1993" is not the marking.
const DOT_ID_NUMBER = /^(UN|NA|ID) ?\d{4}$/;

/** Why this value cannot be saved as a DOT identification number, or undefined when it can. */
export function dotIdNumberProblem(idNumber: string | null | undefined): string | undefined {
  const trimmed = idNumber?.trim();
  if (!trimmed || DOT_ID_NUMBER.test(trimmed)) {
    return undefined;
  }
  return /^\d{4}$/.test(trimmed)
    ? `Identification number "${trimmed}" needs its prefix. Use UN, NA or ID followed by four digits, such as UN${trimmed}.`
    : `Identification number "${trimmed}" is not valid. Use UN, NA or ID followed by four digits, such as UN1993.`;
}
